<script setup lang="ts">
import { onMounted } from 'vue';
import { LAST_PURCHASE_COOKIE } from '@zyro-inc/site-modules/constants/siteModulesConstants';
import { getCookie } from '@zyro-inc/site-modules/utils/cookies';
import ModalContent from '@zyro-inc/site-modules/components/ecommerce/modals/partials/ModalContent.vue';
import ModalLayout from '@zyro-inc/site-modules/components/ecommerce/modals/partials/ModalLayout.vue';
import { useEcommerceModal } from '@zyro-inc/site-modules/components/ecommerce/modals/useEcommerceModal';
import EventLogApi from '@zyro-inc/site-modules/api/EventLogApi';

defineProps<{
	translations: Record<string, string>;
}>();

const { closeEcommerceModal } = useEcommerceModal();

onMounted(() => {
	try {
		EventLogApi.logEvent({
			eventName: 'builder_customers.ecomm.order_failed',
		});

		const lastPurchaseCookie = getCookie(LAST_PURCHASE_COOKIE);

		if (lastPurchaseCookie) {
			const lastPurchaseCookieData = JSON.parse(lastPurchaseCookie);

			if (lastPurchaseCookieData.is_new_checkout === true) {
				EventLogApi.logEvent({
					eventName: 'builder_customers.ecomm_new_checkout.order_failed',
					eventProperties: {
						payment_provider: lastPurchaseCookieData.payment_provider,
						device_mode: lastPurchaseCookieData.device_mode,
						is_express_checkout: false,
					},
				});
			}
		}
	} catch {
		// eslint-disable-next-line no-empty -- Do nothing, analytics related
	}
});
</script>

<template>
	<ModalLayout ref="modal">
		<ModalContent
			qa-selector="failed"
			:title="translations.checkoutModalCantAcceptOrders"
			:text="translations.checkoutModalPleaseContact"
			:button-text="translations.close"
			@handle-close="closeEcommerceModal"
		/>
	</ModalLayout>
</template>
